angular.module('mtic').service('SessionDataService', function (EventManager) {
  var eventManager = new EventManager('SessionDataService')
  var c4DiagPrompted = false;




  // Public Methods
  var SessionDataService = {
      resetSessionVars : function(){
        c4DiagPrompted = false;
      },
      hasShownC4DiagPrompt : function() {
        return c4DiagPrompted;
      },
      disableC4DiagPrompt : function() {
        c4DiagPrompted = true;
      }
  }


  /**
  * Listens to logout event
  */
  eventManager.listen('logout', function () {
    SessionDataService.resetSessionVars();
  });

  return SessionDataService;
})
